module.exports = __webpack_public_path__ + "media/docent.e7bd5b98.webm";